// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__StandardETLErrorMessage___1sLSZ{\n    width: inherit;\n}\n\n.styles-module__StandardETLFileIcon___zx_t- > div[class=\"FileItem\"] > div[class=\"FileItem-file\"] > div[class=\"FileItem-fileContent\"] > i[data-test=\"DesignSystem-FileListItem--Icon\"] {\n    width: 32px !important;\n}\n\n", ""]);
// Exports
exports.locals = {
	"StandardETLErrorMessage": "styles-module__StandardETLErrorMessage___1sLSZ",
	"StandardETLFileIcon": "styles-module__StandardETLFileIcon___zx_t-"
};
module.exports = exports;
